import { Box, Typography, Link, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { t } from '../utils/translations';

const Footer = () => {
  const navigate = useNavigate();
  
  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        px: 2,
        mt: 'auto',
        backgroundColor: (theme) => theme.palette.grey[100],
        borderTop: (theme) => `1px solid ${theme.palette.divider}`
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ 
          display: 'flex', 
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <Typography
            variant="body2"
            color="text.secondary"
          >
            © Bambino {t('Workshop')} {new Date().getFullYear()}
          </Typography>
          
          <Box sx={{ 
            display: 'flex', 
            gap: 3, 
            mt: { xs: 2, sm: 0 } 
          }}>
            <Link
              component="button"
              variant="body2"
              onClick={() => navigate('/support')}
              sx={{ 
                color: 'text.secondary',
                textDecoration: 'none',
                '&:hover': { color: 'primary.main' }
              }}
            >
              {t('Support')}
            </Link>
            
            <Link
              component="button"
              variant="body2"
              onClick={() => navigate('/privacy-policy')}
              sx={{ 
                color: 'text.secondary',
                textDecoration: 'none',
                '&:hover': { color: 'primary.main' }
              }}
            >
              {t('Privacy Policy')}
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer; 